(function() {
  window.CartPage = window.CartPage || new function() {
    var self = this;

    // Store last selected addon variant ID globally (to survive cart refreshes)
    window.lastSelectedAddonVariantId = window.lastSelectedAddonVariantId || null;

    self.updateCart = function() {
      console.log('updateCart triggered');
      $s.showLoadingOverlay();
      $s.getJson({
        url: routes.root_url + '?sections=cart_content',
        success: async function(data) {
          var section = document.querySelector('.cart-content');
          $s.updateDynamicContent(section, data['cart_content']);

          var summaryWrapper = document.querySelector('#cart .summary-column');
          var waterSavior = document.querySelector(".water-safe");
          if (section.querySelector('.cart-items')) {
            summaryWrapper.style.display = '';
            waterSavior.style.display = '';
          } else {
            summaryWrapper.style.display = 'none';
            waterSavior.style.display = 'none';
          }

          await $s.globalEval(data['cart_content']);
          $s.hideLoadingOverlay();

          // Re-initialize everything after AJAX refresh
          restoreAddonSelection();
          bindCartInteractions();     // Includes single remove, quantity, and bundle remove
          updateCartCounts();
          refreshRedoToggle();         // NEW: Force Redo component to update
        }
      });
    };

    self.updateItemsQuantity = function(items, quantity) {
      var data = { updates: {} };
      items.forEach(function(item) {
        data.updates[item.dataset.key] = quantity;
      });
      postUpdate(data);
    };

    async function postUpdate(data) {
      $s.showLoadingOverlay();
      await $s.cartUpdateDataFix(data);
      await $s.post({
        type: 'POST',
        url: routes.cart_url + '/update.js',
        data: data,
        dataType: 'json',
        success: async function(cart) {
          self.updateCart();
        },
        error: $s.addToCartFail
      });
    }
  };

  // Restore and manage the cart addon (upsell/recommended product)
  function restoreAddonSelection() {
    const form = document.getElementById('cart-addon-form');
    if (!form) return;

    const radios  = form.querySelectorAll('input[type="radio"][name="id"]');
    const btn     = document.getElementById('cart-addon-submit');
    const labelEl = document.querySelector('.cart-addon .option-name .option-value');
    const hidden  = form.querySelector('input[data-variant-id="true"]');
    const preview = document.getElementById('addon-preview');

    let restored = false;

    // Try to restore previous selection
    if (window.lastSelectedAddonVariantId) {
      radios.forEach(radio => {
        if (radio.value === window.lastSelectedAddonVariantId && !radio.disabled) {
          radio.checked = true;
          restored = true;
        }
      });
    }

    // If nothing selected or restored, pick first available
    if (!restored && ![...radios].some(r => r.checked)) {
      const firstAvailable = [...radios].find(r => !r.disabled);
      if (firstAvailable) {
        firstAvailable.checked = true;
        window.lastSelectedAddonVariantId = firstAvailable.value;
      }
    }

    function updateUI() {
      let checkedTitle = '';
      let hasChecked = false;

      radios.forEach(r => {
        const sw = r.closest('.swatch');
        const checked = r.checked;
        if (sw) {
          sw.classList.toggle('selected', checked);
          sw.setAttribute('aria-checked', checked ? 'true' : 'false');
        }

        if (checked) {
          hasChecked = true;
          window.lastSelectedAddonVariantId = r.value;

          const span = r.parentElement.querySelector('.label-inner span');
          if (span) checkedTitle = span.textContent.replace(' — Out of stock', '').trim();

          if (hidden) hidden.value = r.value;

          const imgSrc = r.getAttribute('data-img');
          const imgAlt = r.getAttribute('data-alt') || checkedTitle || '';
          if (preview && imgSrc) {
            preview.src = imgSrc;
            if (imgAlt) preview.alt = imgAlt;
          }
        }
      });

      if (btn) btn.disabled = !hasChecked;
      if (labelEl) labelEl.textContent = checkedTitle || '';
    }

    // Event delegation – survives DOM replacements
    form.addEventListener('change', function(e) {
      if (e.target.name === 'id' && e.target.type === 'radio') {
        updateUI();
      }
    });

    updateUI();
  }

  // Re-bind all cart interactions
  function bindCartInteractions() {
    const cart = document.getElementById('cart');
    if (!cart) return;

    // Single item remove buttons – now force full page reload
    cart.querySelectorAll('.remove').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();

        const itemElement = this.closest('.item');
        const key = itemElement.dataset.key;

        if (!key) return;

        // Build updates object to set quantity to 0
        const updates = {};
        updates[key] = 0;

        // Show loading if you have an overlay
        $s.showLoadingOverlay();

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        })
        .then(response => {
          if (!response.ok) throw new Error('Cart update failed');
          return response.json();
        })
        .then(() => {
          // Full page refresh instead of AJAX partial update
          window.location.reload();
        })
        .catch(error => {
          console.error('Error removing item:', error);
          $s.hideLoadingOverlay();
          alert('Something went wrong while removing the item.');
        });
      });
    });

    // Quantity inputs – keep AJAX behavior
    cart.querySelectorAll('.cart-items input[type=number]').forEach(function(input) {
      input.addEventListener('change', function() {
        const itemElement = this.closest('.item');
        const items = $s.getItemsToUpdate ? $s.getItemsToUpdate(itemElement, this.value) : [itemElement];
        CartPage.updateItemsQuantity(items, this.value);
      });
    });

    // Bundle remove buttons – now force full page reload
    cart.querySelectorAll('.remove-bundle-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('Bundle remove clicked');

        const bundleId = this.getAttribute('data-bundle-id');
        if (!bundleId) return;

        const updates = {};
        let hasItemsToRemove = false;

        cart.querySelectorAll('.item[data-bundle-id]').forEach(item => {
          if (item.getAttribute('data-bundle-id') === bundleId) {
            const key = item.getAttribute('data-key');
            if (key) {
              updates[key] = 0;
              hasItemsToRemove = true;
            }
          }
        });

        if (!hasItemsToRemove) return;

        $s.showLoadingOverlay();

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        })
        .then(response => {
          if (!response.ok) throw new Error('Cart update failed');
          return response.json();
        })
        .then(() => {
          // Full page refresh instead of AJAX partial update
          window.location.reload();
        })
        .catch(error => {
          console.error('Error removing bundle:', error);
          $s.hideLoadingOverlay();
          alert('Something went wrong while removing the bundle.');
        });
      });
    });
  }

  // Update cart count badges
  function updateCartCounts() {
    let itemsCount = 0;
    const cart = document.getElementById('cart');
    if (!cart) return;

    cart.querySelectorAll('.cart-items .quantity-box input[type=number]').forEach(function(input) {
      itemsCount += parseInt(input.value) || 0;
    });

    const headerCount = document.querySelector('header .cart-count');
    if (headerCount) headerCount.innerHTML = itemsCount > 0 ? itemsCount : '';

    const pageCount = document.querySelector('#cart .cart-count');
    if (pageCount) pageCount.innerHTML = itemsCount > 0 ? `(${itemsCount})` : '';
  }

  // NEW: Force refresh of Redo toggle component after cart changes
  function refreshRedoToggle() {
    const redoToggle = document.querySelector('redo-shopify-toggle#redo-toggle-fef18818') || document.querySelector('redo-shopify-toggle');
    if (!redoToggle) return;

    // Dispatch common cart update events (many apps listen to these)
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('ajaxCart.afterCartLoad', { bubbles: true }));

    // Trigger change on quantity inputs to wake up subtotal watchers
    document.querySelectorAll('.cart-items input[type=number]').forEach(input => {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // Mutate found-selector attribute to force re-scan
    const currentSelector = redoToggle.getAttribute('found-selector') || '.subtotals';
    redoToggle.setAttribute('found-selector', '');
    setTimeout(() => {
      redoToggle.setAttribute('found-selector', currentSelector);
    }, 150);

    // Re-insert element into DOM to trigger connectedCallback (common for web components)
    const parent = redoToggle.parentNode;
    if (parent) {
      const sibling = redoToggle.nextSibling;
      parent.removeChild(redoToggle);
      parent.insertBefore(redoToggle, sibling);
    }
  }

  // Initial load – run everything once
  document.addEventListener('DOMContentLoaded', function() {
    restoreAddonSelection();
    bindCartInteractions();
    updateCartCounts();
    refreshRedoToggle();  // Initial refresh for Redo

    

    

    if ($s.validateBundlesInJson) {
      $s.getJson({url:'/cart.js'}).then(data => {
        $s.validateBundlesInJson(data.items);
      });
    }
  });

  // Initial cart cache fetch
  if (window.CartCache && CartCache.cart_fetch === null) {
    $s.get({url:'/cart.js'});
  }
})();